import React, { useEffect, useState } from "react";

const Filter = ({
  onFilterChange,
  onSortChange,
  onSearchChange,
  selectedExpertises,
  selectedServices,
  selectedLanguages,
  onExpertiseChange,
  onServiceChange,
  onLanguageChange,
  onClearSelections,
  indicators,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [activeSortOption, setActiveSortOption] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/experts/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }
  const filterOptions = [
    { key: "available", label: languageData.filters.available },
    { key: "favorite", label: languageData.filters.favorite },
  ];

  const handleLinkClick = (filterKey) => {
    let updatedFilters;

    if (activeFilters.includes(filterKey)) {
      updatedFilters = activeFilters.filter((f) => f !== filterKey);
    } else {
      updatedFilters = [...activeFilters, filterKey];
    }
    setActiveFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };

  const handleSortOptionClick = (optionName) => {
    if (activeSortOption === optionName) {
      setActiveSortOption(null);
      onSortChange(null);
    } else {
      setActiveSortOption(optionName);
      onSortChange(optionName);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onSearchChange(value);
  };

  const handleReset = () => {
    setActiveFilters([]);
    setActiveSortOption(null);
    onFilterChange([]);
    onSortChange(null);
  };

  const shouldHideResetButton =
    activeFilters.length === 0 && activeSortOption === null;
  const hasFilters =
    selectedExpertises.length > 0 ||
    selectedServices.length > 0 ||
    selectedLanguages.length > 0;

  const APP_SERVICES = process.env.REACT_APP_APP_SERVICES;
  const SERVICES = APP_SERVICES.split(",").map((s) => s.trim().toLowerCase());

  return (
    <div className="header text-start">
      <div className="col-xxl-12 col-xl-12 col-md-12">
        <div className="card custom-card">
          <div className="card-body p-0">
            <nav className="navbar navbar-expand-xxl bg-white">
              <div className="container">
                <h6 className="mb-0 me-2 text-muted">
                  {languageData.filters.title}:
                </h6>
                <button data-interaction="filter_expert_button"
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse navbar-justified "
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav me-auto align-items-xxl-center resp-my-1 resp-al-center flex align-items-center flex-row gap-1">
                    {filterOptions.map((filter) => (
                      <li
                        className="nav-item flex ml-3p"
                        key={filter.key}
                      >
                        <a data-interaction="filter_by_button"
                          className={`nav-link ${
                            activeFilters.includes(filter.key) ? "active" : ""
                          }`}
                          href="#"
                          onClick={() => handleLinkClick(filter.key)}
                        >
                          {filter.label}{" "}
                        </a>
                      </li>
                    ))}

                    <li className="nav-item dropdown flex ">
                      <a data-interaction="sort_expert_button"
                        className="nav-link btn  btn-primary-light dropdown-toggle position-relative"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        {languageData.filters.sort}
                      </a>
                      <ul className="dropdown-menu position-absolute">
                        {["reading", "newest", "rating"].map((sortOption) => (
                          <li key={sortOption}>
                            <a data-interaction="sort_experts_dropdown"
                              className={`dropdown-item ${
                                activeSortOption === sortOption ? "active" : ""
                              }`}
                              href="#"
                              onClick={() => handleSortOptionClick(sortOption)}
                            >
                              {languageData.filters[`sort_${sortOption}`]}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                    {!shouldHideResetButton && (
                      <li className="nav-item">
                        <button data-interaction="reset_filter_experts_button"
                          className="btn btn-sm reset_btn"
                          onClick={handleReset}
                        
                        >
                          {languageData.filters.reset || "Reset"}
                        </button>
                      </li>
                    )}
                  </ul>
                  <div className="d-flex" role="search">
                    <input
                      className="form-control form-control-sm me-1"
                      type="search"
                      name="search"
                      placeholder={languageData.filters.search}
                      aria-label="Search"
                      value={searchValue}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <div className="flex-column expertise_filter resp-my-1 hidden">
                    {/* Expertises Section */}
                    <div className=" border-bottom">
                      <p className="fw-semibold mb-0 text-muted flex">
                        {languageData.sidebar.expertises.title}
                      </p>
                      <div className="py-3 pb-0 text-start">
                        {Object.entries(languageData.sidebar.expertises).map(
                          ([key, value]) =>
                            key !== "title" && (
                              <div className="form-check mb-2" key={key}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={key}
                                  name="expertise"
                                  checked={selectedExpertises.includes(key)}
                                  onChange={onExpertiseChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={key}
                                >
                                  {value}
                                </label>
                                <span className="badge bg-light text-muted float-end">
                                  {indicators.expertises[key.toLowerCase()] ||
                                    0}
                                </span>
                              </div>
                            ),
                        )}
                      </div>
                    </div>

                    {/* Services Section */}
                    <div className=" border-bottom">
                      <p className="fw-semibold mb-0 text-muted flex">
                        {languageData.sidebar.service.title}
                      </p>
                      <div className="py-3 pb-0 text-start">
                        {Object.entries(languageData.sidebar.service).map(
                          ([key, value]) =>
                            key !== "title" &&
                            SERVICES.includes(key.toLowerCase()) && (
                              <div className="form-check mb-2" key={key}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={key}
                                  name="service"
                                  checked={selectedServices.includes(key)}
                                  onChange={onServiceChange}
                                />

                                <label
                                  className="form-check-label"
                                  htmlFor={key}
                                >
                                  {value}
                                </label>

                                <span className="badge bg-light text-muted float-end">
                                  {indicators.services[key] || 0}
                                </span>
                              </div>
                            ),
                        )}
                      </div>
                    </div>

                    {/* Languages Section */}
                    <div className="border-bottom">
                      <p className="fw-semibold mb-0 text-muted flex">
                        {languageData.sidebar.languages.title}
                      </p>
                      <div className="py-3 pb-0 text-start">
                        {Object.entries(languageData.sidebar.languages).map(
                          ([key, value]) =>
                            key !== "title" && (
                              <div className="form-check mb-2" key={key}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="languages"
                                  id={key}
                                  checked={selectedLanguages.includes(key)}
                                  onChange={onLanguageChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={key}
                                >
                                  {value}
                                </label>
                                <span
                                  className="badge bg-light text-muted float-end ml-50p"
                                >
                                  {indicators.languages[key.toLowerCase()] || 0}
                                </span>
                              </div>
                            ),
                        )}
                      </div>
                    </div>

                    {/* Reset Button */}
                    {hasFilters && (
                      <div className="p-4">
                        <button data-interaction="reser_filter_experts_button"
                          className="btn btn-sm w-100 reset_btn"
                          onClick={onClearSelections}
                          
                        >
                          {languageData.filters.reset || "Reset"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
